// extracted by mini-css-extract-plugin
module.exports = {"items":"Newsposts-module--items--JEOnH","link":"Newsposts-module--link--2dnJX","active":"Newsposts-module--active--3gdCz","button":"Newsposts-module--button--PRWj8"};